import React from 'react';
import { Play } from 'lucide-react';

export interface StartSpeechButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isFeeding?: boolean;
  label?: string;
  className?: string;
}

/**
 * Universal Bloom Primary Action Canon for Start Speech:
 * - deep slate-blue / navy fill (bg-slate-800)
 * - white text (text-white)
 * - white or soft-slate play icon (text-slate-200 fill-current)
 * - crisp slate border (border-slate-700)
 * - subtle neutral shadow only (shadow-xs)
 * - restrained hover/pressed state (hover:bg-slate-700 active:bg-slate-900 active:scale-98)
 * - no bright royal/electric blue, neon cyan, glow, bloom, arcade gradient, or luminous border
 */
export const START_SPEECH_CANON_CLASS =
  'px-3 py-1.5 text-xs font-semibold rounded-lg flex items-center space-x-1.5 transition-colors active:scale-98 cursor-pointer shrink-0 bg-slate-800 hover:bg-slate-700 active:bg-slate-900 text-white border border-slate-700 shadow-xs';

export const StartSpeechButton: React.FC<StartSpeechButtonProps> = ({
  isFeeding = false,
  label,
  className = '',
  type = 'button',
  ...props
}) => {
  return (
    <button
      type={type}
      className={`${START_SPEECH_CANON_CLASS} ${className}`.trim()}
      {...props}
    >
      <Play className="w-3 h-3 fill-current text-slate-200 shrink-0" />
      <span className="whitespace-nowrap tracking-tight">
        {label || (isFeeding ? 'Start Feeding' : 'Start Speech')}
      </span>
    </button>
  );
};

export default StartSpeechButton;
